module.exports = __webpack_public_path__ + "static/Evervault-63ab944e2e4d6656fd9d9228d13221a4.jpg";